const base = { width: 24, height: 24, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round', 'aria-hidden': true } as const;

export const HomeIcon = () => (
  <svg {...base}>
    <path d="M3 11l9-7 9 7v9a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z" />
  </svg>
);
export const HandoverIcon = () => (
  <svg {...base}>
    <path d="M4 7h11l-3-3M20 17H9l3 3" />
  </svg>
);
export const CaseIcon = () => (
  <svg {...base}>
    <path d="M4 5h16v15H4z" />
    <path d="M8 9h8M8 13h8M8 17h5" />
  </svg>
);
export const TruckIcon = () => (
  <svg {...base}>
    <path d="M2 6h12v10H2zM14 10h4l3 3v3h-7" />
    <circle cx="6" cy="18" r="2" />
    <circle cx="17" cy="18" r="2" />
  </svg>
);
export const MoreIcon = () => (
  <svg {...base}>
    <circle cx="5" cy="12" r="1.5" />
    <circle cx="12" cy="12" r="1.5" />
    <circle cx="19" cy="12" r="1.5" />
  </svg>
);
export const CameraIcon = () => (
  <svg {...base}>
    <path d="M3 8h4l2-3h6l2 3h4v11H3z" />
    <circle cx="12" cy="13" r="3.5" />
  </svg>
);
export const ImageIcon = () => (
  <svg {...base}>
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <circle cx="9" cy="10" r="2" />
    <path d="M21 16l-5-5-9 9" />
  </svg>
);
export const BackIcon = () => (
  <svg {...base}>
    <path d="M15 5l-7 7 7 7" />
  </svg>
);
export const ChevronIcon = () => (
  <svg {...base} width={18} height={18}>
    <path d="M9 5l7 7-7 7" />
  </svg>
);
export const DownloadIcon = () => (
  <svg {...base} width={20} height={20}>
    <path d="M12 4v11M7 10.5l5 5 5-5M5 20h14" />
  </svg>
);
export const AlertIcon = () => (
  <svg {...base}>
    <path d="M12 3l10 18H2z" />
    <path d="M12 10v5M12 18v.01" />
  </svg>
);
export const BulbIcon = () => (
  <svg {...base}>
    <path d="M9 18h6M10 21h4M12 3a6 6 0 0 0-4 10.5c.7.7 1 1.5 1 2.5h6c0-1 .3-1.8 1-2.5A6 6 0 0 0 12 3z" />
  </svg>
);
export const PinIcon = () => (
  <svg {...base} width={18} height={18}>
    <path d="M12 21s7-6.2 7-11.5A7 7 0 0 0 5 9.5C5 14.8 12 21 12 21z" />
    <circle cx="12" cy="9.5" r="2.5" />
  </svg>
);
export const CloseIcon = () => (
  <svg {...base}>
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
);
export const CheckIcon = () => (
  <svg {...base}>
    <path d="M5 12.5l4.5 4.5L19 7" />
  </svg>
);
export const BorderIcon = () => (
  <svg {...base}>
    <path d="M4 21V4M4 4h10l-2 4 2 4H4" />
  </svg>
);
export const BodyIcon = () => (
  <svg {...base}>
    <rect x="3" y="8" width="18" height="8" rx="4" />
    <path d="M7 12h10" />
  </svg>
);
export const FlagIcon = () => (
  <svg {...base}>
    <path d="M12 21s7-6.2 7-11.5A7 7 0 0 0 5 9.5C5 14.8 12 21 12 21z" />
    <path d="M9 9.5l2 2 4-4" />
  </svg>
);
